import React, { useEffect, useState } from 'react'
import IconClose from '../../vectors/IconClose'

import {
  NewsStripEl,
  NewsStripItems,
  NewsStripItem,
  NewsStripItemContent,
  NewsStripIcon,
  NewsStripHeadline,
  NewsStripDescription,
  NewsStripButton,
  NewsStripDismiss
} from './elements'

const NewsStrip = ({ items, dismissId }) => {
  const [activeIndex, updateActiveIndex] = useState(0)
  const [dismissed, setDismissed] = useState(
    dismissId
      ? typeof window !== 'undefined' &&
          window.localStorage.getItem(`promoDismissed-${dismissId}`)
      : false
  )
  const maxIndex = items.length - 1

  const handleSetDismissed = () => {
    setDismissed(true)
    if (dismissId)
      typeof window !== 'undefined' &&
        window.localStorage.setItem(`promoDismissed-${dismissId}`, 'true')
  }

  const handleActiveIndex = () => {
    updateActiveIndex((activeIndex) =>
      activeIndex < maxIndex ? activeIndex + 1 : 0
    )
  }

  useEffect(() => {
    let activeIndexTimer = setInterval(handleActiveIndex, 8000)

    return () => {
      clearInterval(activeIndexTimer)
    }
  }, [])

  return (
    <span id="news-strip-placeholder">
      {!dismissed && (
        <NewsStripEl>
          <NewsStripDismiss onClick={handleSetDismissed}>
            <IconClose />
          </NewsStripDismiss>
          <NewsStripItems>
            {items.map(
              (
                { headline, description, callToActionLink, callToActionText },
                i
              ) => (
                <NewsStripItem
                  active={i === activeIndex}
                  key={`NewsStrip-${headline}`}
                >
                  <NewsStripIcon>
                    <svg viewBox="0 0 30 25">
                      <path d="M14.3 23.5l-5.2-1.1v-2.9l5.2.7v3.3zM0 7v9.7c0 1 .7 1.8 1.7 2l6.1.8V23c0 .3.2.6.5.6l6.5 1.3h.1c.4 0 .7-.3.7-.7v-3.9l6.5.9v-19L1.7 5C.7 5.2 0 6 0 7z" />
                      <path d="M29.3 0c-.4 0-.7.3-.7.7v.8l-5.2.7v19.3l5.2.7v.8c0 .4.3.7.7.7.4 0 .7-.3.7-.7V.7c0-.4-.3-.7-.7-.7z" />
                    </svg>
                  </NewsStripIcon>
                  <NewsStripItemContent>
                    <NewsStripHeadline>{headline}</NewsStripHeadline>
                    {description && (
                      <NewsStripDescription>
                        {' '}
                        – {description}
                      </NewsStripDescription>
                    )}
                  </NewsStripItemContent>
                  {callToActionLink && (
                    <NewsStripButton href={callToActionLink}>
                      {callToActionText}
                    </NewsStripButton>
                  )}
                </NewsStripItem>
              )
            )}
          </NewsStripItems>
        </NewsStripEl>
      )}
    </span>
  )
}

export default NewsStrip
